import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-resource_2group",
  "use": "icon-resource_2group-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-resource_2group\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M24,8.36H0V2.17C0,1.49.54.4,1.2.4h8.9l2.4,3H22.8A1.23,1.23,0,0,1,24,4.65Zm0,2.48V22.36a1.22,1.22,0,0,1-1.2,1.24H1.2A1.22,1.22,0,0,1,0,22.36V10.84Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol